<!-- 跟踪记录管理 -->
<template>
  <BaseContainer class="tab-detart-manage" :loading="listLoading" :isHasPageFt="!listLoading">

    <template v-slot:hd>
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="searchVal.searchText" placeholder="联系人电话 / 客户地址" style="width:200px;"
            @keyup.enter.native="getList(1)"></el-input>
        </el-form-item>

        <el-form-item>
          <el-date-picker style="width:160px;" v-model="searchVal.payVisitDate" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" type="date" placeholder="拜访日期"> </el-date-picker>
        </el-form-item>

        <!-- <el-form-item v-if="userInfo.type == 1">
              <SelectCommon  placeholder="客户经理" style="width: 130px" :clearable="true" apiPath="/tbAdminuser/manageList" :keys="{label: 'name', value: 'id'}" @change="(value, datas) => handleSelectCommon(value, datas, 'managerAdminuser')" />
            </el-form-item> -->

        <el-form-item>
          <el-select v-model="searchVal.payVisitStatus" placeholder="拜访方式" style="width:110px;" clearable>
            <el-option v-for="item in visitStatusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-model="searchVal.auditStatus" placeholder="审核状态" style="width:110px;" clearable>
            <el-option v-for="item in checkStatusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="medium" @click="getList(1)">查询</el-button>
          <el-button type="primary" size="medium" plain icon="el-icon-plus" @click="addForm" v-if="userInfo.type != 1">新
            增</el-button>
        </el-form-item>
      </el-form>
    </template>

    <template v-slot:main>
      <el-table :data="dataList" highlight-current-row @selection-change="handerSectionChange"
        @row-click="handerRowClick" style="width: 100%;" ref="companyTabRef" :row-style="{ height: '50px' }">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" :index="indexMethod" label="序号" width="70">
          <template slot-scope="scope">
            <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="payVisitDate" width="120" label="拜访日期" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.payVisitDate ? scope.row.payVisitDate.split(" ")[0] : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="adminUserName" width="100" label="客户经理" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.adminUserName ? scope.row.adminUserName.split(" ")[0] : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="successfulManagerName" width="110" label="客户成功经理" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.successfulManagerName ? scope.row.successfulManagerName.split(" ")[0] : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="agencyManagerName" width="100" label="经销商" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.agencyManagerName ? scope.row.agencyManagerName.split(" ")[0] : '-' }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="createUserName" width="100" label="创建人"  show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="contactUser" width="120" label="联系人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contactPhone" width="120" label="联系人电话" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.contactPhone ? scope.row.contactPhone : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="payVisitStatus" width="120" label="拜访方式" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="myTag-fill"
              :class="scope.row.payVisitStatus == 1 ? 'pruple' : (scope.row.payVisitStatus == 2 ? 'primary' : 'warning')">
              {{ scope.row.payVisitStatus == 1 ? "电话沟通" : (scope.row.payVisitStatus == 2 ? '客户现场' : '视频会议') }}
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="auditStatus" width="120" label="审核状态" show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- 1、待审核 2：已审核  -->
            <span class="myTag" :class="scope.row.auditStatus == 1 ? 'warning' : 'primary'">
              {{ scope.row.auditStatus == 1 ? "待审核" : '已审核' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="position" label="职位" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.position ? scope.row.position : '-' }}
          </template>
        </el-table-column>

        <el-table-column prop="addressInfo" label="客户地址" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.addressInfo || '' }}
          </template>
        </el-table-column>

        <el-table-column label="操作" style="text-algin:center" min-width="120">
          <template slot-scope="scope">
            <span class="operate">
              <el-tooltip effect="dark" content="详情" placement="top">
                <span class="dnnfont iconfile-search" @click="handleDetail(scope.$index, scope.row, 1)"></span>
              </el-tooltip>

              <!-- 自己查看删除自己的: 已审核的不能操作 scope.row.auditStatus == 1 && -->
              <el-tooltip effect="dark" content="编辑" placement="top"
                v-if="scope.row.auditStatus == 1 && userInfo.id == scope.row.createUser">
                <span class="dnnfont iconEdit" @click="handleEdit(scope.$index, scope.row)"></span>
              </el-tooltip>

              <el-tooltip effect="dark" content="删除" placement="top"
                v-if="scope.row.auditStatus == 1 && userInfo.id == scope.row.createUser">
                <span class="dnnfont icondelete" @click="handleDel(scope.$index, scope.row)"></span>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
      </el-table>

      <ModalForm :visible.sync="visible" :mode="mode" :visitStatusList="visitStatusList" @getList="getList"
        :processDetail="processDetail" v-if="visible" />
      <ModalFormView :visible.sync="visibleView" :visitStatusList="visitStatusList" @getList="getList"
        :processDetail="processDetail" v-if="visibleView" />

    </template>

    <template v-slot:ft>
      <el-col :span="24" class="toolbar" style="position: relative">
        <el-pagination layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 50, 100]" :current-page="pageNumber"
          :page-size="pageSize" :total="total" @current-change="handleCurrentChange" @size-change="handleSizeChange"
          style="float:right;">
        </el-pagination>
      </el-col>
    </template>
  </BaseContainer>
</template>

<script>
import { mapGetters } from 'vuex'
import { API_userCom } from '@/api/index.js'
import BaseContainer from '@/components/BaseContainer'
import SelectCommon from '@/components/SelectCommon'
import ModalForm from './ModalForm.vue'
import ModalFormView from './ModalFormView.vue'
import utils from '@/utils/index'
export default {
  data() {
    return {
      listLoading: false,
      dataList: [],

      // 分页信息
      pageNumber: 1,
      pageSize: 20,
      total: 0,

      visible: false,
      visibleView: false,
      mode: 'save',

      searchVal: {
        searchText: '',
        payVisitStatus: '',      // 拜访状态
        auditStatus: '',         // 审核状态
        managerAdminuser: '',
        payVisitDate: ''
      },

      selectedUserId: [],
      visitStatusList: [
        { label: '电话沟通', value: '1' },
        { label: '客户现场', value: '2' },
        { label: '视频会议', value: '3' },
      ],

      checkStatusList: [
        { label: '待审核', value: '1' },
        { label: '已审核', value: '2' },
      ],

      processDetail: null,
      token: ''
    };
  },

  components: {
    BaseContainer,
    SelectCommon,
    ModalForm,
    ModalFormView
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    })
  },

  created() {
    let { token, checkCode } = utils.getParamsByCookie();
    this.token = token;
    this.getList();
  },

  methods: {
    getList() {
      this.listLoading = true;
      let data = {
        token: this.token,
        compayId: this.$route.query.companyId,
        page: this.pageNumber,
        size: this.pageSize,
        ...this.searchVal
      }
      API_userCom.getTrackList(data).then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;
          this.dataList = data.list;
          this.total = data.totalRow
        }
        this.listLoading = false;
      }).catch(err => {
        this.listLoading = false;
      })

    },

    // 客户经理过滤
    handleSelectCommon(value, datas, key) {
      this.searchVal.managerAdminuser = value[0]
    },


    handerSectionChange(data, column, event) {
      // console.log("handerSectionChange==", data)
      this.selectedUserId = data.length > 0 ?
        data.map(item => item.id) : []

    },

    // 单击行
    handerRowClick(row, column, event) {
      // console.log("handerRowClickrow==", row, event.target)
      if (event.target.className.indexOf('dnnfont') > -1) {
        return;
      }
      this.$refs.companyTabRef.toggleRowSelection(row);
    },



    // 新增
    addForm() {
      this.processDetail = null;
      this.visible = true;
      this.mode = 'save'
    },

    // 删除
    handleDel(index, row) {
      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let param = {
          token: this.token,
          checkCode: this.checkCode,
          id: row.id,
          del: 0
        }
        API_userCom.updateTrack(param)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message({ message: '删除成功', type: 'success' });
              this.getList();
            } else {
              this.$message.error(res.data.message);
              if (res.data.code == 403) {
                this.$router.push({ path: 'loginAdmin' });
              }
            }
          }).catch(err => {
            this.$message.error('数据丢失，试试重新登陆！');
          })
      }).catch(err => {
      });
    },

    handleEdit(index, row) {
      this.processDetail = row
      this.visible = true;
      this.mode = 'update'
      console.log("handleEdit==", this.visible)
    },

    // 详情
    handleDetail(index, row) {
      this.processDetail = row
      this.visibleView = true;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },

    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    indexMethod(index) {
      return (index + 1) + (this.pageNumber - 1) * this.pageSize;
    },


  }
}

</script>
<style lang='scss' scoped>
.tab-detart-manage {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>


// WEBPACK FOOTER //
// index.vue?4e39f258